/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Run `npm run generate-api` to regenerate.
 */
import { z } from 'zod';

import { zEnumWithUnknownFallback, zRequired } from '@/shared/redux/api/utils/zod-helpers';

export const identPublicValidators: Record<string, z.ZodTypeAny> = {
  "CreateTenant": z.object({ "createTenant": z.object({ "tenantId": z.string(), "existingUser": z.boolean().nullish() }) }),
  "ConfirmUser": z.object({ "confirmUser": zRequired.nullish() }),
  "ForgotPassword": z.object({ "forgotPassword": z.object({ "isPasswordReset": z.boolean(), "nextStep": z.object({ "resetPasswordStep": z.string() }) }) }),
  "ReadIdentityProviderByEmail": z.object({ "readIdentityProviderByEmail": z.object({ "identityProviderId": z.string() }) }),
};
